var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, EButtonType } from 'src/ui/components/button/Button';
import { useAutoSearchConfig, useAutoSearchPolling } from './hooks';
import { E_REQUEST_STATUS } from 'src/shared/types';
import { Loader } from 'src/ui/components/Loader/Loader';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import styles from './autoSearch.module.scss';
export var AutoSearch = function () {
    var _a = useAutoSearchConfig(), i18n = _a.i18n, hasAutoSearchPermission = _a.hasAutoSearchPermission;
    var _b = useAutoSearchPolling(), updateAutoPlay = _b.updateAutoPlay, autoPlay = _b.autoPlay, results = _b.results, status = _b.status;
    var isFinished = status === E_REQUEST_STATUS.FINISHED;
    var isLoading = status === E_REQUEST_STATUS.LOADING;
    var isEmpty = results.length === 0 && isFinished && autoPlay;
    var startLabel = getPropsByKeyPath(i18n, 'view.autoSearch.actions.activate');
    var emptyTitle = getPropsByKeyPath(i18n, 'view.autoSearch.emptyResult.title');
    var emptyDescription = getPropsByKeyPath(i18n, 'view.autoSearch.emptyResult.description');
    var noPermissionLabel = getPropsByKeyPath(i18n, 'view.autoSearch.actions.noPermissionLabel');
    var title = getPropsByKeyPath(i18n, 'view.autoSearch.default.title');
    var description = getPropsByKeyPath(i18n, 'view.autoSearch.default.description');
    if (!i18n) {
        return _jsx(Loader, {});
    }
    if (isLoading) {
        return (_jsx("div", __assign({ className: styles.autoSearchWrapper }, { children: _jsx("div", __assign({ className: styles.autoSearchDescriptions }, { children: _jsx(Loader, {}) })) })));
    }
    if (isEmpty) {
        return (_jsx("div", __assign({ className: styles.autoSearchWrapper }, { children: _jsxs("div", __assign({ className: styles.autoSearchDescriptions }, { children: [_jsx("h2", { children: emptyTitle }), _jsx("p", __assign({ className: styles.autoSearchText }, { children: emptyDescription }))] })) })));
    }
    return (_jsxs("div", __assign({ className: styles.autoSearchWrapper }, { children: [_jsxs("div", __assign({ className: styles.autoSearchDescriptions }, { children: [_jsx("h2", { children: title }), _jsx("p", __assign({ className: styles.autoSearchText }, { children: description }))] })), _jsx(Button, { type: EButtonType.VALID, label: startLabel, leftIcon: E_ICONS.EMPTY_BOLT, onClick: function () { return updateAutoPlay(true); }, isLoading: isLoading, classname: styles.autoSearchButton, title: hasAutoSearchPermission ? noPermissionLabel : null, disabled: !hasAutoSearchPermission })] })));
};
